import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { postLiquidationDifferenceReason } from '../../../../actions';
import { LIQUIDATION_DIFFERENCE_REASON_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import LiquidationDifferenceReasonForm from './LiquidationDifferenceReasonForm';

const NewLiquidationDifferenceReason = ({ breadcrumbs, dispatchpostLiquidationDifferenceReason }) => {
  const onSubmit = (formValues) =>
    dispatchpostLiquidationDifferenceReason({
      ...formValues,
    });

  const content = <LiquidationDifferenceReasonForm onSubmit={onSubmit} />;
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Discrepancia de Liquidación"
      subtitle="Crear una nueva discrepancia de liquidación."
      content={content}
    />
  );
};

const mapDispatchToProps = {
  dispatchpostLiquidationDifferenceReason: postLiquidationDifferenceReason,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Discrepancias de Liquidación',
      href: LIQUIDATION_DIFFERENCE_REASON_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

NewLiquidationDifferenceReason.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchpostLiquidationDifferenceReason: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewLiquidationDifferenceReason);
